<template>
  <div class='contact-page image-header-container'>
    <t-header :class='{fixed: fixedHeader}'/>
    <div class='top-container'>
      <h2>联系我们</h2>
      <p>您的满意是我们的追求---感谢您对马兰头的关注<br/>您有什么需要或者在使用产品过程中遇到什么问题，请与我们联系，我们将竭诚为您服务!</p>
    </div>
    <div class='info'>
      <div class='contact-type'>
        <div>
          <span class='circle'>
            <img src='../assets/contact/01.png'/>
          </span>
          <div class='right'>
            <p>服务热线：</p>
            <p>400-646-1860</p>
          </div>
        </div>
        <div>
          <span class='circle'>
            <img src='../assets/contact/02.png'/>
          </span>
          <div class='right'>
            <p>官方客服邮箱：</p>
            <p>developer@mlt-med.com</p>
          </div>
        </div>
      </div>
      <ul class='company'>
        <li>
          <h3>马兰头医学科技(杭州)有限公司</h3>
          <p>地址： 杭州市萧山区启迪路198号杭州湾信息港D座18楼</p>
          <p>电话： 400-646-1860</p>
          <p>邮件：developer@mlt-med.com</p>
          <p>邮编： 311221</p>
        </li>
        <li>
          <h3>马兰头医学科技（美国）</h3>
          <p>地址：2100 Geng Road, Embarcadero Place, Suite 210 Palo Alto, CA 94303</p>
          <p>电话：Phone: 408-666-1950</p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import THeader from '../components/header';
import imageHeaderMixin from '../mixins/imageHeader';

export default {
  metaInfo: {
    title: '马兰头医学科技——云通信专家，提供专业的实时音视频PaaS服务',
    meta: [
      {
        name: 'keywords',
        content: '语音通话,视频通话,语音视频,实时消息,直播连麦,互动直播,互动白板,实时互动,即时通讯,实时音视频,实时通信,rtc,声网'
      },
      {
        name: 'description',
        content: '马兰头医学科技新一代实时通信平台,致力于实时音视频PaaS平台在不同领域的应用, 推出了远程医疗、在线教育、电力建筑、娱乐社交等一系列解决方案,4行代码即可快速搭建应用，支持私有化部署'
      },
    ]
  },
  name: 'Contact',
  components: {
    THeader,
  },
  mixins: [imageHeaderMixin],
  data() {
    return {
      scrollTopMax: 150
    }
  },
}
</script>

<style lang="less">
.contact-page {
  .top-container {
    height: 400px !important;
    color: #fff;
    text-align: center;
    h2 {
      padding-top: 125px;
      font-size: 32px;
      font-weight: 600;
      color: #ffffff;
      margin-bottom: 53px;
    }
    p {
      font-size: 16px;
      font-weight: 400;
      color: #ffffff;
      line-height: 28px;
    }
  }
  .info {
    width: 800px;
    margin: 0 auto;
    padding: 40px 0;
    .contact-type {
      display: flex;
      > div {
        flex: 1;
        display: flex;
        align-items: center;
        .circle {
          width: 78px;
          height: 78px;
          background: #fcfdff;
          border-radius: 50%;
          box-shadow: 0px 0px 8px 0px rgba(210,221,231,0.50); 
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .right {
          margin-left: 23px;
          font-size: 18px;
          font-weight: 400;
          color: #666666;
          line-height: 25px;
          p:last-child {
            font-size: 21px;
            font-weight: 600;
            color: #0e2267;
            line-height: 29px;
          }
        }
      }
    }
    .company {
      margin-top: 40px;
      li {
        &:first-child {
          margin-bottom: 93px;
        }
        h3 {
          font-size: 21px;
          font-weight: 600;
          color: #0e2267;
          line-height: 29px;
          margin-bottom: 30px;
        }
        p {
          font-size: 18px;
          font-weight: 400;
          color: #333333;
          line-height: 30px;
        }
      }
    }
  }
}
</style>